import { ReactNode } from 'react';
import IntersectionObserver from '@researchgate/react-intersection-observer';

import useWindowSize from '@/hooks/useWindowSize';
import { useSafeAreaInsets } from '@/hooks/useSafeAreaInsets';

type Props = {
  children: ReactNode;
  id: string;
  onIntersection: (event: IntersectionObserverEntry) => void;
};

export const NarrativeIntersectionObserver = ({
  children,
  id,
  onIntersection,
}: Props) => {
  const { height } = useWindowSize();
  const isServerSide = RUNTIME_ENV === 'server';
  const safeAreaInsets = useSafeAreaInsets();

  if (isServerSide) {
    return <>{children}</>;
  }

  const topMargin = 121 + safeAreaInsets.top;
  const bottomMargin = height ? height - topMargin : 0;
  const rootMargin = `-${topMargin}px 0px -${bottomMargin}px 0px`;

  return (
    <IntersectionObserver
      onChange={onIntersection}
      threshold={0}
      rootMargin={rootMargin}
    >
      <div id={id}>{children}</div>
    </IntersectionObserver>
  );
};
